import React, { useState } from "react";
import api from "../../utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      return toast.error("Passwords do not match");
    }

    try {
      await api.post("/auth/register", { email, password });
      toast.success("Registration successful! Please log in.");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: 400 }}>
      <h2>New Registration unavailable </h2>
      {/* <form onSubmit={handleRegister}>
        <input
          type="email"
          className="form-control my-2"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <div className="d-flex align-items-center gap-2">
          <input
            type={show ? "text" : "password"}
            className="form-control my-2"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {show ? (
            <FaEye onClick={() => setShow((prev) => !prev)} />
          ) : (
            <FaEyeSlash onClick={() => setShow((prev) => !prev)} />
          )}
        </div>
        <div className="d-flex align-items-center gap-2">
          <input
            type={show ? "text" : "password"}
            className="form-control my-2"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />

          {show ? (
            <FaEye onClick={() => setShow((prev) => !prev)} />
          ) : (
            <FaEyeSlash onClick={() => setShow((prev) => !prev)} />
          )}
        </div>
        <button type="submit" className="btn btn-primary w-100 mt-2">
          Register
        </button>
      </form>
      <p className="mt-3 text-center">
        Already have an account? <a href="/">Login</a>
      </p> */}
    </div>
  );
}
